import { KeyValuePipe, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { IconComponent } from '@fino-ui/icon';
import { ModalService } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';
import { isEmpty } from 'lodash-es';
import { AppService } from 'src/app/app.service';
import type { Archiving } from '../../kwh.model';
import { ArchivingService } from './archiving.service';
import { ArchivingSettings } from './components/settings/settings.component';
import { ARCHIVING_MAP, DOCUMENT_TYPES } from './kwh.archiving';

@Component({
  selector: 'app-archiving',
  templateUrl: './archiving.component.html',
  styleUrl: './archiving.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslationModule,
    IconComponent,
    NgClass,
    ButtonModule,
    KeyValuePipe,
  ],
})
export class ArchivingComponent {
  constructor(
    private archivingService: ArchivingService,
    private ngxModalService: ModalService,
    private appService: AppService,
  ) {}
  archivingSettings = input.required<Archiving>();
  @Output() archivingChanged = new EventEmitter();

  archivingDocTypes = DOCUMENT_TYPES;
  archivingMap = ARCHIVING_MAP;

  isArchivingActive = computed(() => {
    const settings = this.archivingSettings();
    return settings?.flow !== 'NONE';
  });

  getDocumentStatus(transferringType: string, documentType: string) {
    if (!this.isArchivingActive()) return false;
    const settings = this.archivingSettings();
    if (!settings) return false;
    // cant archive the document type for the given transferringType
    const archivingNotPossible =
      !ARCHIVING_MAP[transferringType].includes(documentType);

    if (archivingNotPossible) return null;

    const { docTypes } = settings;
    const getArchived = docTypes.includes(
      `${transferringType}_${documentType}`,
    );
    return getArchived;
  }

  getIconForArchiving(transferringType: string, documentType: string) {
    const documentStatus = this.getDocumentStatus(
      transferringType,
      documentType,
    );
    if (documentStatus === true) return 'Check';
    if (documentStatus === false) return 'Remove Bold';
    return 'Road Sign No Entry';
  }

  ctaLabel = computed(
    () =>
      `kwh.actions.archiving.openModal.${this.isArchivingActive() ? 'configure' : 'enable'}`,
  );

  getIconClassForArchiving(transferringType: string, documentType: string) {
    const documentStatus = this.getDocumentStatus(
      transferringType,
      documentType,
    );
    if (documentStatus === true) return 'has-icon-success';
    else if (documentStatus === false) return 'has-icon-danger';
    return '';
  }

  get reportDownloading() {
    return !this.archivingService.reportSubscription.closed;
  }

  downloadReport() {
    this.archivingService.downloadReport();
  }

  openModal() {
    this.ngxModalService
      .addModal(ArchivingSettings, {
        archiving: this.archivingSettings(),
      })
      .subscribe((result) => {
        if (isEmpty(result)) return;
        this.archivingChanged.emit(result);
      });
  }
}
